const en = {
    resources: {
        documentation: "Documentation",
        alreadyTranslate: "%{message}",
        file: {
            success: "File deleted successfully",
            remove: "Unable to delete file (%{err})"
        },
        enabled: {
            generic: "The form is invalid",
            wrongReturnType: "Return type for validation is wrong format"
        },
        disabled: {
            generic: "The form cannot be deactivated",
            wrongReturnType: "Return type for deactivation is wrong format"
        },
        validate: {
            coherenceDate: "The start date must be less than or equal to the end date",
            requiredFieldFor: "\"%{field}\" is required for \"%{for}\"",
            unitTime: "Please enter your time"
        },
        login: {
            back: "Unreachable authentication server"
        },
        settings: "Settings",
        bulkAssignMyself: "Assign to myself",
        forceGo: "Force complete",
        forceBack: "Force cancel",
        editTitle: "Edit",
        loading: "Loading...",
        add: "Add",
        remove: "Remove",
        cancel: "Cancel",
        close: "Close",
        start: "Start",
        assign: "Assign",
        unassign: "Unassign",
        valid: "Validate",
        reject: "Reject",
        activate: "Check and activate",
        deactivate: "Deactivate",
        details: "Details",
        undefined: {
            name: '??? |||| ???',
        },
        role: {
            admin: "Administrator",
            projectManager: "Project manager",
            teamManager: "Team Manager",
            productor: "Productor"
        },
        unitTime: {
            hour: "Hour(s)",
            minute: "Minute(s)"
        },
        unitTimeTranslate: {
            hour: "%{value}  hour |||| %{value} hours",
            minute: "%{value}  minute |||| %{value} minutes"
        },
        tracking: {
            waiting: "Waiting",
            inProgress: "In progress",
            completed: "Completed"
        },
        status: {
            draft: "Draft",
            enabled: "Enabled",
            disabled: "Disabled"
        },
        taskStatus: {
            waiting: "Waiting",
            available: "Available",
            assigned: "Assigned",
            completed: "Completed",
            rejected: "Rejected",
            cancelled: "Cancelled"
        },
        common: {
            actionTitle: {
                deactivate: "Deactivation %{resourceName}"
            },
            actionContent: {
                deactivate: "Are you sure you want to deactivate %{resourceName}? This action is irreversible and will hide, by default, this resource on all screens, however duplication will remain possible."
            },
        },
        workflow: {
            name: 'the workflow |||| Workflows',
            errors: {
                endShouldBeConnectedToStart: "The start must be connected to the end in an error-free flow passing through at least one step",
                atLeastOne: "A workflow should have at least one stage",
                stageWithoutIn: "The stage \"%{name}\" has no incoming connection",
                stageNeedOutgoing: "The stage \"%{name}\" doesn't have an error-free outbound connection",
                stageReferenceItselfIncoming: "The stage \"%{name}\" has a circular reference to itself (error-free stream should not loop)",
                stageShouldBeConnectToStart: "The stage \"%{name}\" is not connected to start (via parent or itself)"
            },
            fields: {
                id: "Id",
                name: "Name",
                description: "Description",
                model: "Model",
                ownerId: "Owner"
            }
        },
        geometry: {
            import: "Import geometries",
            importTitle: "Please upload a CSV file containing a 'geometry' field and one or more attributes to identify the production unit.\nEither 'id' or 'name' + 'lotId' or 'name' + 'lotName'.\n'id' corresponds to the production unit's identifier, and 'name' refers to the production unit's name. The geometry must be with an EPSG:3857 projection",
            filled: "Has a geometry",
            failed: "The geometry is not a valid GeoJSON",
            empty: "Does not have a geometry",
            summary: {
                added: "1 geometry is updated |||| %{smart_count} geometries are updated",
                notJSON: "dont 1 geométrie n'est pas au format geojson |||| dont %{smart_count} geométries ne sont pas au format geojson",
                noGeometry: "1 line does not contain a \"geometry\" attribute |||| %{smart_count} lines do not contain a \"geometry\" attribute",
                noRelatedAttribute: "1 line does not contain an attribute to identify the production unit |||| %{smart_count} lines do not contain an attribute to identify the production unit",
                notFound: "1 line does not correspond to a production unit in your project |||| %{smart_count} lines do not correspond to production units in your project",
                nothing: "The file does not contain any data to import"
            }
        },       
        project: {
            name: "the project |||| Projects",
            showGrid: "Show as grid",
            showSchema: "Show as schema",
            errors: {
                for: "for the stage \"%{name}\""
            },
            map: {
                name: "Map",
                title: "Project map"
            },
            stats: {
                name: "Statistics",
                title: "Project statistics"
            },
            stages: {
                name: "Stages assignment",
                legend: "Please click on the stage you wish to assign",
                quantity: "The team must produce",
                duration: "In a delay of"
            },
            lot: {
                name: "Lots allocation"
            },
            delegate: {
                name: "Delegation"
            },
            fields: {
                id: "Id",
                name: "Name",
                description: "Description",
                workflowId: "Workflow",
                unitProd: "Production unit name",
                unitMeasure: "Measure unit",
                atheneo: "ATHENEO number",
                hasCustomDashboard: "Has a custom dashboard?",
                hasExternalProductionFile: "Has an external production file system?",
                hasExternalProductionFileHelper: "By default, the system allow you to drop smalls production files but  you can use an external system file. Then when a task is created you could join a link to your own file system (\"sharepoint\"...)",
                hasMap: "Has a map?",
                customDashboardId: "Custom dashboard id",
                ownerId: "Owner"
            }
        },
        stage_infos: {
            name: "Stage informations",
            fields: {
                quantity: "Quantity",
                duration: "Duration",
                unitTime: "Time unit",
                stageId: "Stage name",
                assignId: "Team in charge of the stage",
                isSubproject: "Is a subproject?",
                isMultipleTeam: "Is multiple team?",
                subprojectId: "Subproject"
            }
        },
        team: {
            name: "the team |||| Teams",
            member: "Productor",
            fields: {
                id: "Id",
                name: "Name",
                description: "Description",
                managerId: "Manager",
                members: "Productors"
            }
        },
        project_delegate: {
            mydelegate: "My project delegate team manager",
            others: "Others available team manager",
            add: "Team manager add to the project",
            remove: "Team manager remove from the project"
        },
        userTeam: {
            myteam: "My team",
            others: "Others available productors",
            add: "User add to the team",
            remove: "User remove from the team"
        },
        user: {
            name: "the user |||| Users",
            identity: "Identity",
            fields: {
                id: "Id",
                firstname: "Firstname",
                lastname: "Lastname",
                fullname: "Fullname",
                email: "Email",
                role: "Role"
            }
        },
        lot: {
            name: "the production lot |||| Production lots",
            validate: {
                projectEnabled: "The associated project should be enabled",
                empty: "The lot is empty, please add some production units"
            },
            fields: {
                id: "Id",
                name: "Name",
                startDate: "Start date",
                endDate: "End date",
                projectId: "Project",
                tracking: "Status"
            }
        },
        production_unit: {
            name: "the production unit |||| Production units",
            details: "Details units production",
            create: "Create units production",
            fields: {
                id: "Id",
                name: "Name",
                stageName: "Stage",
                quantity: "Quantity",
                quantityReal: "Real quantity",
                comment: "Comments",
                lotId: "Production lot",
                numberProductionUnits: "Number of production units",
                automaticIncrementName: "Automatically incremented names",
                tracking: "Status"
            }
        },
        task: {
            name: "the task |||| Tasks",
            validate: {
                needComment: "To reject a task, you must enter a comment.",
                needNextTeam: "To validate this task, you must enter the next team",
                needRejectTeam: "To reject this task, you must enter the reject team"
            },
            actionTitle: {
                cancel: "Cancel the task",
                bulkAssignMyself: "Assign selection to myself",
                bulkUnassign: "Unassign selection",
                forceGo: "Force selected tasks end",
                forceBack: "Force selected tasks reactivation",
            },
            actionContent: {
                cancel: "Are you sure you want to cancel this task? This is not the normal workflow process, it will recreate any previous tasks.",
                bulkAssignMyself: "Are you sure you want to unassign to yourself the selected tasks?",
                bulkUnassign: "Are you sure you want to unassign the selected tasks?",
                forceGo: "Do you really want to force the end of the selected tasks? Note that this does not allow you to enter the time as well as the comments and does not create tasks for subprojects.",
                forceBack: "Are you sure you want to force cancel the selected tasks? The attached work units will become in progress again, as well as the selected tasks.",
            },
            success: {
                cancel: "The task has been canceled and its previous stages have been recreated",
                bulkAssign: "The task has been assigned |||| The tasks have been assigned",
                bulkUnassign: "The task has been unassigned |||| The tasks have been unassigned",
                forceGo: "The task has been completed |||| Tasks have been completed",
                forceBack: "The task has been reactivated |||| Tasks have been reactivated"
            },
            error: {
                bulkAssignMyselfSubproject: "This task has a subproject, so it cannot be assigned |||| At least one task has a sub-project which therefore cannot be mass assigned",
            },
            fields: {
                sub: "Cut into the subproject",
                team: "Team",
                project: "Project",
                lot: "Production lot",
                "stage.name": "Stage",
                productionUnitId: "Production unit",
                "production_unit.lot.endDate": "Lot end date",
                estimateTime: "Estimate time",
                inputTime: "Input time",
                taskStatus: "Status",
                quantity: "Quantity",
                quantityTask: "Observed quantity",
                "production_unit.lot.name": "Lot name",
                assignTo: "Assign to",
                comment: "Comments",
                commentTask: "Add a comment",
                endDate: "End date",
                assignedDate: "Assigned date",
                availableDate: "Available date",
                previousProductionFileExternal: "Previous production file",
                previousProductionFile: "Previous production file",
                previousShuttleFile: "Previous shuttle file",
                productionFileExternal: "Production file",
                productionFile: "Production file",
                shuttleFile: "Shuttle file",
                nextTeamAssignTo: "Team assigned to next task",
                rejectTeamAssignTo: "Team assigned to reject task"
            }
        }
    }
};
export default en;